import { HlrEnvironment } from '@helpers/types/models';

export const environment: HlrEnvironment = {
	production: true,
	version: '2.6.0',

	protocol: '',
	host: '',
	port: '',
	api: 'v2',
	localStorageKey: 'hlr',
	configURL: `./assets/config.json?v=${new Date().getTime()}`,

	title: 'MNP Configurator',
	subTitle: '',

	theme: 'blue',
	themeType: window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light',

	termsUrl: '',
	privacyUrl: '',
	supportEmail: '',

	showLink: true,
	allowRegistration: false,

	systemTZOffset: 0,
	localTime: false,

	languagesID: ['en', 'es', 'ru', 'cn'],

	releaseDate: '05.16.2025',

	is2FA: false,
	sessionTimeout: 0,

	wsHost: '',
	wsPort: '',
	wsApi: '',
};
